import { Button } from '@/components'
import { Dialog } from '@/components/UI'
import { HtmlContent } from '@/components/UI/HtmlContent'
import type React from 'react'
import { useTranslation } from 'react-i18next'
// import SnsShareBanner from '@/components/molecules/SnsShare/SnsShareBanner'

type Props = {
  opened: boolean
  title?: string
  description?: string
  image?: string | null
  point?: number | null
  error?: string
  onClose: () => void
  onAllClose: () => void
  /** 最後に表示しているスタンプかどうか。true: 最後のスタンプ。false: 2個以上ある状態のスタンプ */
  isLastStamp: boolean
  stampName: string
  campaign: {
    type: 1 | 2 | 3
    stampShape: 0 | 1
    stampPopup?: { icons: string[]; message: string }
    custom?: 'NTT' | 'SHOKYOTO2025' | 'NEXTTUBE' | 'NTTBS' | 'SOKOSHIGA'
  }
}

/**
 * スタンプを再度表示時に使うコンポーネント。
 */
export const DialogRedisplayStamps = ({
  opened,
  title,
  description,
  image,
  point,
  error,
  onClose,
  onAllClose,
  campaign,
  isLastStamp,
  stampName,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={opened} closeFunc={onAllClose} closeOnClickOutside={false} title={title}>
      {error && <p className="mt-5 mb-5 text-center text-sm">{error}</p>}

      {campaign.type === 1 && image && (
        <>
          {/* 丸スタンプ: 非正方形画像でも中央基準でトリミングして円形に収める（#3450） */}
          {campaign.stampShape === 0 && (
            <div className="mx-auto mt-4 h-40 w-40 overflow-hidden rounded-full">
              <img src={image} alt="" data-testid="stamp-dialog-image" className="h-full w-full object-cover" />
            </div>
          )}
          {campaign.stampShape === 1 && (
            <div className="relative mx-auto mt-4 h-40 w-40 overflow-hidden text-center">
              <img
                src={image}
                alt=""
                data-testid="stamp-dialog-image"
                className="absolute top-1/2 left-1/2 h-auto w-auto max-h-full max-w-full -translate-x-1/2 -translate-y-1/2 object-contain"
              />
            </div>
          )}
        </>
      )}
      <p className="text-gray-600 mt-4 text-center text-sm font-bold">{stampName}</p>

      {(campaign.type === 2 || campaign.type === 3) && point && (
        <div className="mx-auto mt-4 text-center">
          <p className="text-[140px] font-bold">
            {point}
            <span className="text-[30px]">pt</span>
          </p>
        </div>
      )}

      {description && <HtmlContent html={description} className="text-gray-600 mt-4 text-center text-sm font-bold" />}

      {campaign.stampPopup && (
        <>
          <div className="mt-8 flex justify-center">
            {campaign.stampPopup.icons.map((icon, i) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: 同じアイコン画像が重複し得る静的リストのため index を key に使用
              <img key={i} src={icon} className="mx-2 h-8 w-8 object-contain" alt="" />
            ))}
          </div>

          <HtmlContent html={campaign.stampPopup.message} className="text-gray-600 mt-4 text-sm font-bold" />
        </>
      )}
      {/*<SnsShareBanner onClick={() => {}}/>*/}
      {campaign?.custom === 'NTTBS' && (
        <a href="https://raund.net" target="_blank" rel="noopener noreferrer">
          <img src={`${process.env.NEXT_PUBLIC_ASSETS_URL}/system/banner.png`} alt="raund" />
        </a>
      )}
      {isLastStamp ? (
        <>
          <div className="mt-10 text-center">
            <Button label={t('common.close', '閉じる')} fullWidth onClick={onClose} />
          </div>
        </>
      ) : (
        <>
          <div className="mt-10 text-center">
            <Button label={t('common.popup.next', '次へ')} fullWidth onClick={onClose} />
          </div>
        </>
      )}
    </Dialog>
  )
}
